<template>
    <v-dialog v-model="showDialog" max-width="540px">
        <template v-slot:activator="{ on }">
            <div class="modal-close-btn">
                <v-btn
                        fab
                        elevation="0"
                        color="#f4f5f6"
                        height="22"
                        width="22"
                        v-on="on"
                >
                    <v-icon size="14" color="grey">mdi-close</v-icon>
                </v-btn>
            </div>
        </template>
        <v-card
                class="pa-10 roommate-remove-modal"
        >
            <v-row>
                <v-col>
                    <h4 class="text-center">
                        Remove Roommate?
                    </h4>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <p class="text-center">
                        Removing a roommate will unlink them from your account and they will no longer receive any emails regarding your apartment search.
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex justify-center">
                    <v-btn
                            class="btn-edurent mr-2"
                            width="165"
                            height="45"
                            depressed
                            outlined
                            color="primary"
                            @click="showDialog=false"
                    >
                        No, Cancel
                    </v-btn>
                    <v-btn
                            class="btn-edurent ml-2 white--text"
                            width="165"
                            height="45"
                            depressed
                            color="#FF4141"
                            :loading="isRemovingRoommate"
                            @click="removeRoommate"
                    >
                        Yes, Remove
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>

</template>

<script>
    import RoommateService from "@/services/roommate.service";

    export default {
        name: 'RoommateRemove',
        props: {
          roommateId: {
            type: Number,
            required: true
          },
          isRemovingRoommate: {
            type: Boolean,
            default: false
          }
        },
        data() {
          return {
            showDialog: false
          }
        },
      methods: {
        async removeRoommate() {
          let error = false
          this.isRemovingRoommate = true
          await RoommateService.removeRoommate(this.roommateId).catch(() => {
            error = true
          })
          this.isRemovingRoommate = false
          if (error) {
            return
          }

          this.showDialog = false;
          this.$store.dispatch('getUserRoommates')
        }
      }
    }
</script>

<style>

    .roommate-remove-modal {
        border-radius: 10px !important;
    }
    .roommate-remove-modal h4 {
        font-size: 20px !important;
        font-weight: 700;
    }
    .roommate-remove-modal p {
        font-size: 14px !important;
    }

</style>
